//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HeadBar} from '@/components';
import XButton from "vux/src/components/x-button/index";
import {OrderProxy} from "@/http/RequestProxy.class";

const orderProxy = new OrderProxy();

export default {
  name: 'payment-success',
  components: {
    XButton,
    HeadBar,
  },
  data(){
    return {
      orderInfo: null,
    };
  },
  computed: {
    orderId(){
      return this.$route.params.order_id;
    }
  },
  mounted(){
    this.getOrderDetail();
  },
  methods: {
    /** 获取订单详情 */
    getOrderDetail(){
      this.$vux.loading.show();
      orderProxy.getOrderDetail({order_id: this.orderId})
        .then(resp => {
          if(resp){
            const response = {result: 'success'};

            this.orderInfo = resp.data;
            if(Number(resp.data.pay_at_code) <= 0){
              this.backToPay();
            }else{
              if(this.isAppEnv()){
                window.webkit.messageHandlers.LFPrompt.postMessage(response);
              }
            }
          }
          this.$vux.loading.hide();
        });
    },

    viewOrder(){
      this.$router.push({name: 'hotel-order-detail', params: {order_id: this.orderId}});
    },

    backToHome(){
      this.$router.push({name: 'hotel'})
    },

    backToPay() {
      const response = {result: 'pay'};

      if(this.isAppEnv()){
        window.webkit.messageHandlers.LFPrompt.postMessage(response);
      }else {
        this.$router.push({name: 'hotel-payment', query: {order_id: this.orderId}})
      }
    },

    /** 判断是否是在app中打开页面 */
    isAppEnv(){
      return (window.webkit && typeof window.webkit.messageHandlers.LFPrompt != 'undefined');
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/payment/payment-success.vue